const Company = () => {
	return (
		<ul className="dropdown dropdown-company">
			<li className="company-li">History</li>
			<li className="company-li">Our Team</li>
			<li className="company-li">Blog</li>
		</ul>
	);
};

export default Company;
